module.exports = __webpack_public_path__ + "static/media/01.c46b9c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/home/01.png
// module id = 794
// module chunks = 0